import { object, string } from "yup";

export const DEFAULT_VALUES = {};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  position: string().required("Harus diisi"),
  email: string().email("Email tidak valid").nullable(),
  phoneNumber: string().required("Harus diisi"),
});
